import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseModelService {

  public data: any;
  private stg: Storage | null = null;

  abstract tableName: string;

  constructor(
    public storage: Storage
  ) {
    this.initStorage();
  }


  /**
   * Obtiene la colección o un elemento por ID
   *
   */
  public async list(ID?: number): Promise<any> {
    const val = await this.storage.get(this.tableName);
    const aux = JSON.parse(val);

    if (ID && aux) {
      return aux.find((item: any) => item.id == ID);
    }

    return aux;
  }


  /**
   * Guarda la colección
   *
   */
  public async save(data: any): Promise<any> {
    this.data = data;

    return this.storage
      .set(this.tableName, JSON.stringify(data))
      .then(() => this.data);
  }


  /**
   * Añade o actualiza un elemento en la colección
   *
   */
  public async set(data: any, id?: number) {

    if (!id) {
      await this.add(data);
      return;
    }

    await this.update(id, data);
  }


  /**
   * Añade un nuevo elemento a la colección
   *
   */
  async add(data: any): Promise<any> {
    const resources = await this.list();

    if (!resources) {
      return this.data;
    }

    resources.push(data);
    return this.save(resources);
  }


  /**
   * Actualiza un elemento existente en la colección
   *
   */
  public async update(id: number, newData: any): Promise<any> {
    const resources = await this.list();

    if (!resources) {
      return this.data;
    }

    const index = Object.keys(resources).find((key) => resources[key].id === id) ?? null;

    if (index && index != '-1') {
      resources[index] = newData;
    }

    return this.save(resources);
  }


  /**
   * Elimina un elemento de la colección
   *
   */
  public async remove(id: any): Promise<any> {
    const resources = await this.list();

    if (!resources) {
      return this.data;
    }

    const index = Object.keys(resources).find((key) => resources[key].id === id);

    if (index != '-1') {
      resources.splice(index, 1);
    }

    return this.save(resources);
  }


  /**
   * Elimina toda la colección
   *
   */
  public async delete(): Promise<any> {
    this.data = null;
    await this.storage.remove(this.tableName);
  }


  /**
   * Inicializa el storage
   *
   */
  private async initStorage() {
    this.stg = await this.storage.create();
  }

}


/**
 * Clase base para los modelos
 *
 */
export class BaseDtoModel {

  constructor(dataJson?: any) {

    if (!dataJson) {
      return;
    }

    Object.assign(this, dataJson);
  }


  /**
   * Inicializa los campos con valores por defecto y elimina los obsoletos
   *
   */
  protected init(defaults: Record<string, any>) {
    const validKeys: string[] = Object.keys(defaults);

    for (const key of validKeys) {

      if ((this as any)[key] === undefined) {
        (this as any)[key] = defaults[key];
      }

    }

    for (const key of Object.keys(this)) {

      if (!validKeys.includes(key)) {
        delete (this as any)[key];
      }

    }
  }

}


/**
 * Interfaz base para objetos
 *
 */
export interface BaseDto {
  [key: string]: any;
}
